export const inferenceModels = {
    id: "inference",
    name: "Inference",
    api: "https://inference.net/v1",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://inference.net/models",
    env: ["INFERENCE_API_KEY"],
    models: {
        "meta/llama-3.2-3b-instruct": {
            id: "meta/llama-3.2-3b-instruct",
            name: "Llama 3.2 3B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2025-01-01",
            last_updated: "2025-01-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.02,
                output: 0.02,
            },
            limit: {
                context: 16000,
                output: 4096,
            },
        },
        "meta/llama-3.2-1b-instruct": {
            id: "meta/llama-3.2-1b-instruct",
            name: "Llama 3.2 1B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2025-01-01",
            last_updated: "2025-01-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.01,
                output: 0.01,
            },
            limit: {
                context: 16000,
                output: 4096,
            },
        },
        "meta/llama-3.1-8b-instruct": {
            id: "meta/llama-3.1-8b-instruct",
            name: "Llama 3.1 8B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2025-01-01",
            last_updated: "2025-01-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.025,
                output: 0.025,
            },
            limit: {
                context: 16000,
                output: 4096,
            },
        },
        "meta/llama-3.2-11b-vision-instruct": {
            id: "meta/llama-3.2-11b-vision-instruct",
            name: "Llama 3.2 11B Vision Instruct",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2025-01-01",
            last_updated: "2025-01-01",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.055,
                output: 0.055,
            },
            limit: {
                context: 16000,
                output: 4096,
            },
        },
        "mistral/mistral-nemo-12b-instruct": {
            id: "mistral/mistral-nemo-12b-instruct",
            name: "Mistral Nemo 12B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-12",
            release_date: "2025-01-01",
            last_updated: "2025-01-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.038,
                output: 0.1,
            },
            limit: {
                context: 16000,
                output: 4096,
            },
        },
        "google/gemma-3": {
            id: "google/gemma-3",
            name: "Google Gemma 3",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-12",
            release_date: "2025-01-01",
            last_updated: "2025-01-01",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.3,
            },
            limit: {
                context: 125000,
                output: 4096,
            },
        },
        "osmosis/osmosis-structure-0.6b": {
            id: "osmosis/osmosis-structure-0.6b",
            name: "Osmosis Structure 0.6B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-12",
            release_date: "2025-01-01",
            last_updated: "2025-01-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.5,
            },
            limit: {
                context: 4000,
                output: 2048,
            },
        },
        "qwen/qwen-2.5-7b-vision-instruct": {
            id: "qwen/qwen-2.5-7b-vision-instruct",
            name: "Qwen 2.5 7B Vision Instruct",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-12",
            release_date: "2025-01-01",
            last_updated: "2025-01-01",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.2,
            },
            limit: {
                context: 125000,
                output: 4096,
            },
        },
        "qwen/qwen3-embedding-4b": {
            id: "qwen/qwen3-embedding-4b",
            name: "Qwen 3 Embedding 4B",
            attachment: false,
            reasoning: false,
            temperature: false,
            tool_call: false,
            knowledge: "2024-12",
            release_date: "2025-01-01",
            last_updated: "2025-01-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.01,
                output: 0,
            },
            limit: {
                context: 32000,
                output: 2048,
            },
        },
    },
};
export default inferenceModels;
//# sourceMappingURL=inference.js.map